// Conversion tracking. Runs only if the visitor accepted analytics cookies
// (PostHog is only initialised after consent, see public/index.html).
// 1) When a visitor clicks a link to the app's sign up page it gets utm tags, so the app can record
//    which website page each trial came from.
// 2) Clicks on those links, GP calculator use and FAQ opens are sent to PostHog.

function pageName(pathname) {
  if (pathname === "/") return "home";
  return pathname.replace(/^\/+|\/+$/g, "").replace(/\//g, "-") || "home";
}

function capture(event, props) {
  try {
    if (window.posthog && window.__barloAnalyticsStarted) window.posthog.capture(event, props);
  } catch (e) {
    /* analytics must never break the page */
  }
}

function tagLink(a, page) {
  try {
    const url = new URL(a.getAttribute("href"));
    url.searchParams.set("utm_source", "website");
    url.searchParams.set("utm_medium", "cta");
    url.searchParams.set("utm_content", page);
    a.setAttribute("href", url.toString());
  } catch (e) {
    /* leave the link as it is */
  }
}

let installed = false;
export function installClickTracking() {
  if (installed) return;
  installed = true;
  // Capture phase, so the utm tags are on the link before the browser follows it.
  document.addEventListener("click", (e) => {
    const a = e.target.closest && e.target.closest('a[href^="https://app.barloapp.co.uk/register"]');
    if (a) {
      tagLink(a, pageName(window.location.pathname));
      const url = new URL(a.href);
      capture("trial_click", {
        page: pageName(window.location.pathname),
        plan: url.searchParams.get("plan") || "none",
        billing: url.searchParams.get("billing") || "none",
      });
    }
    const summary = e.target.closest && e.target.closest("details > summary");
    if (summary) capture("faq_open", { question: summary.textContent.replace("+", "").trim() });
  }, true);
}

export function trackCalculatorUse() {
  capture("gp_calculator_used", { page: "bar-gp-calculator" });
}
